import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import { useLocale } from '@kts/i18n';
import { statusDef, tr, type Locale, type StatusGroup, type Tone } from '@kts/shared';

export interface BadgeProps {
  tone?: Tone;
  dot?: boolean;
  size?: 'sm' | 'md';
  className?: string;
  children: ReactNode;
  title?: string;
}

export function Badge({ tone = 'neutral', dot, size = 'md', className, children, title }: BadgeProps) {
  return (
    <span className={clsx('kts-badge', size === 'sm' && 'kts-badge--sm', className)} data-tone={tone} title={title}>
      {dot && <span className="kts-badge__dot" />}
      {children}
    </span>
  );
}

/**
 * Status yorlig'i — rang va nom `@kts/shared` dagi status guruhidan olinadi (yagona manba).
 * Til joriy tildan olinadi; `locale` berilsa (hisobot, PDF) o'sha ustun turadi.
 */
export function StatusPill({
  group,
  value,
  locale,
  size,
}: {
  group: StatusGroup;
  value: string | null | undefined;
  locale?: Locale;
  size?: 'sm' | 'md';
}) {
  const active = useLocale();
  const d = statusDef(group, value);
  return (
    <Badge tone={d.tone} dot size={size}>
      {tr(d, locale ?? active)}
    </Badge>
  );
}
